import { Steps } from 'antd'
import EmptyCircle from 'components/icons/EmptyCircle'
import StepRejected from 'components/icons/StepRejected'
import StepsCompletedEvaluation from 'components/icons/StepsCompletedEvaluation'
import StepsCompletedRed from 'components/icons/StepsCompletedRed'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

const { Step } = Steps

const Div = styled.div`
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: #f0f0f0 !important; // Add your custom background color for finished steps
  }
`

const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 50rem !important;
  }
`

export const RoundDiv = styled.p`
  font-weight: ${FONT.FW_500};
  font-size: 15px;
  line-height: 21px;
  color: ${props => props.textcolor};
  width: 100%;
  padding-bottom: 15px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`

const AntdStepsWithPanel = ({
  steps,
  current = 1,
  direction = 'vertical',
  size = 'small',
  onChange,
  checkLine = false,
  ...props
}) => {
  return (
    <Div>
      <Steps
        direction={direction}
        size={size}
        current={current}
        {...props}
        onChange={onChange}
      >
        {steps?.map((step, index) => {
          const statusIcon =
            step?.status === 'SHORTLISTED' &&
            step?.interviewArray?.length > 0 ? (
              <StepsCompletedEvaluation />
            ) : step?.status === 'SELECTED' ? (
              <StepsCompletedEvaluation />
            ) : step?.status === 'REJECTED' ? (
              <StepRejected />
            ) : step?.status === 'HELD_TO_COMPARE' ? (
              <StepsCompletedRed />
            ) : (
              <EmptyCircle />
            )

          return (
            <StyledStep
              key={index + 'statusIco'}
              icon={statusIcon}
              description={
                <RoundDiv
                  style={{
                    borderBottom: checkLine
                      ? 'none'
                      : `1px solid ${COLORS.GREY_T_90}`,
                    color:
                      step?.activeKey === current
                        ? COLORS.GREY_T_30
                        : COLORS.GREY_T_60,
                  }}
                >
                  {step?.description}
                </RoundDiv>
              }
              title={<div>{step?.title}</div>}
            />
          )
        })}
      </Steps>
    </Div>
  )
}

export default AntdStepsWithPanel
